"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Safetycompliancecta() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".cta-eyebrow", {
        y: 12
      });
      gsap.set(".cta-headline", {
        y: 32,
        filter: "blur(12px)"
      });
      gsap.set(".cta-sub", {
        y: 20
      });
      gsap.set(".cta-actions", {
        y: 20
      });
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        },
        defaults: {
          ease: "power3.out"
        }
      });
      tl.to(".cta-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7
      }).to(".cta-headline", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 1.1
      }, "-=0.4").to(".cta-sub", {
        opacity: 1,
        y: 0,
        duration: 0.8
      }, "-=0.6").to(".cta-actions", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.08
      }, "-=0.4");
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".cta-eyebrow", ".cta-headline", ".cta-sub", ".cta-actions"], {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31163" id="safetycompliancecta" className="relative overflow-hidden bg-background text-foreground" style={{
    paddingTop: "clamp(7rem, 13vw, 11rem)",
    paddingBottom: "clamp(7rem, 13vw, 11rem)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(ellipse 60% 40% at 50% 100%, hsl(215 90% 45% / 0.1), transparent 70%)"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" style={{
      width: "min(80vw, 900px)",
      height: "min(60vw, 500px)",
      background: "radial-gradient(ellipse at center, hsl(215 80% 20% / 0.08), transparent 65%)",
      filter: "blur(60px)"
    }} />

      <div ref={container} className="relative mx-auto flex flex-col items-center text-center" style={{
      maxWidth: "1200px",
      paddingLeft: "clamp(1.25rem, 5vw, 4rem)",
      paddingRight: "clamp(1.25rem, 5vw, 4rem)"
    }}>
        <span className="cta-eyebrow mb-8 inline-block font-medium uppercase" style={{
        opacity: 0,
        color: "var(--primary)",
        fontSize: "0.6875rem",
        letterSpacing: "0.22em",
        lineHeight: 1
      }}>
          {"SOLUÇÕES"}
        </span>

        <h2 className="cta-headline font-sans" style={{
        opacity: 0,
        color: "var(--foreground)",
        fontSize: "clamp(3.25rem, 8.2vw, 7.5rem)",
        fontWeight: 450,
        letterSpacing: "-0.035em",
        lineHeight: 0.94,
        maxWidth: "18ch"
      }}>
          {"Engenharia de precisão industrial."}
        </h2>

        <p className="cta-sub mt-8 font-sans" style={{
        opacity: 0,
        color: "var(--muted-foreground)",
        fontSize: "clamp(1.0625rem, 1.15vw, 1.2rem)",
        fontWeight: 350,
        letterSpacing: "-0.005em",
        lineHeight: 1.55,
        maxWidth: "56ch"
      }}>
          {"Representantes exclusivos da Spraying Systems Co. desde 1993. Qualidade técnica superior."}
        </p>

        <div className="mt-12 flex w-full flex-col items-center justify-center gap-4 sm:w-auto sm:flex-row">
          <Button asChild className="cta-actions group h-auto w-full rounded-lg border-0 bg-primary py-3.5 pl-7 pr-2 text-base font-medium tracking-tight text-primary-foreground shadow-md hover:bg-primary/90 sm:w-auto" style={{
          opacity: 0
        }}>
            <Link to="/ProductsPage" className="inline-flex items-center gap-4">
              <span>{"Ver produtos"}</span>
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg transition-transform duration-300 group-hover:-rotate-45" style={{
              backgroundColor: "var(--background)",
              color: "var(--primary)"
            }}>
                <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
              </span>
            </Link>
          </Button>

          <Button asChild variant="outline" className="cta-actions h-auto w-full rounded-lg border py-3.5 px-7 text-base font-medium tracking-tight backdrop-blur-xl sm:w-auto" style={{
          opacity: 0,
          backgroundColor: "var(--muted)",
          borderColor: "var(--border)",
          color: "var(--foreground)"
        }}>
            <Link to="/ContactsPage">{"Consulte-nos"}</Link>
          </Button>
        </div>
      </div>
    </section>;
}